import { useState, useEffect } from 'react'
import { Box, Link, Typography } from '@mui/material'
import usePaymentInfo from '../hooks/usePaymentInfo'
import { FeeSchedule } from './FeeSchedule'

const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    height: '100%'
  },
  iframe: {
    width: '100%',
    height: '100%',
    border: 'none'
  },
  link: {
    cursor: 'pointer',
    fontWeight: 'bold'
  }
}

const PaymentInfo = () => {
  const [tipaltiUrl, setTipaltiUrl] = useState('')
  const { fetchTipaltiUrl } = usePaymentInfo()

  const [modalVisible, setModalVisible] = useState(false)

  const toggleModal = () => setModalVisible(!modalVisible)

  useEffect(() => {
    const fetchUrl = async () => {
      const url = await fetchTipaltiUrl()
      setTipaltiUrl(url)
    }

    fetchUrl()
  }, [fetchTipaltiUrl])

  return (
    <Box sx={styles.container}>
      {tipaltiUrl && (
        <iframe role="tipalti-iframe" src={tipaltiUrl} style={styles.iframe} />
      )}
      <Typography variant="h6" align="center">
        To view the fee schedule for all payout methods{' '}
        <Link
          variant="h6"
          component="span"
          sx={styles.link}
          onClick={toggleModal}
          data-testid="fee-schedule-link"
        >
          click here
        </Link>
      </Typography>
      <FeeSchedule open={modalVisible} onClose={toggleModal} />
    </Box>
  )
}

export default PaymentInfo
